import { setNotifications } from '../../../store/actions/notificationActions';
import { clearMessage, setMessage } from '../../../store/actions/dialogActions';
import { authLogout } from '../../../store/actions/authActions';
import { getAllDocuments } from "./getAllDocuments";
import API from "../../../store/api";
import { clearDocuments } from "../../../store/actions/documentActions";

export const deleteDocument = (id, bearerAuth, formFunction) => {
  return async dispatch => {

    dispatch(setMessage({ type: 'LOAD' }))

    API.delete(`/api/portal/document/${id}`)
      .set('Authorization', `Bearer ${bearerAuth}`)
      .ok(res => res.status === 200 || res.status === 401)
      .then((response) => {
        if (response.status === 200) {
          dispatch(clearMessage)
          dispatch(getAllDocuments(bearerAuth))
          dispatch(setNotifications({
            type: 'success',
            message: 'Successfully deleted.'
          }))
          formFunction()
        } else if (response.status === 401) {
          dispatch(clearDocuments);
          dispatch(authLogout);
        }
      }).catch((error) => {
        let message = 'An error has occurred';
        if (error.message) {
          message = error.message;
        }
        if (error.response && error.response.body) {
          if (error.response.body.messages) {
            message = error.response.body.messages.toString();
          }
        }
        dispatch(setMessage({
          title: 'Delete Document Failed',
          message: message,
          type: 'ERR',
        }))
      })
  }
}